export const CDN_BASE_URL = import.meta.env.VITE_CDN_BASE_URL.replace(/\/+$/, '')

export function cdnUrl(path = '') {
  return `${CDN_BASE_URL}/${String(path).replace(/^\/+/, '')}`
}
